import type { ReportState } from './types'
import { type ReportAction, ReportActionType } from '../actions/ReportActions'

export const initialReportState: ReportState = {
  submittingToAddress: '',
  submittedToAddress: '',
  error: ''
}

export function reportReducer (state = initialReportState, action: ReportAction): ReportState {
  if (action.type === ReportActionType.REPORT_RESET) {
    return { ...initialReportState }
  }

  if (action.type === ReportActionType.REPORT_PENDING) {
    return {
      ...state,
      submittingToAddress: action.payload.email
    }
  }

  if (action.type === ReportActionType.REPORT_FULFILLED) {
    return {
      ...state,
      submittingToAddress: '',
      submittedToAddress: action.payload.email,
      error: ''
    }
  }

  if (action.type === ReportActionType.REPORT_REJECTED) {
    return {
      ...state,
      submittingToAddress: '',
      error: action.payload.error
    }
  }

  return state
}
